import { render } from "./TopicSectionComponent.vue?vue&type=template&id=60fec3ec"
import script from "./TopicSectionComponent.vue?vue&type=script&lang=js"
export * from "./TopicSectionComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__